import vuetify from "@/main";
import MattersPage from "./MattersPage.vue";
import CreateMatter from "./CreateMatter.vue";
angular.module("leanlaw").config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("matters", {
    track: "Matter: List",
    url: "/matters",
    ...vuetify(MattersPage, undefined, "edit")
  }).state("matters.newMatter", {
    url: "/newMatter",
    params: {
      matter: {},
      clientId: null,
      methodOverride: null
    },
    views: {
      edit: {
        template: require("./views/create.html"),
        controller: "MattersCreateCtrl"
      }
    }
  }).state("matters.matter2", {
    url: "/matter2",
    params: {
      matter: {},
      clientId: null,
      methodOverride: null
    },
    views: {
      edit: {
        ...vuetify(CreateMatter)
      }
    }
  }).state("matters.connect", {
    url: "/connect/{id}",
    params: {
      clientId: null,
      matterId: null
    },
    views: {
      edit: {
        template: require("../accounting/views/matter.edit.html"),
        controller: "MatterAccountingEditCtrl"
      }
    }
  }).state("matters.trust", {
    url: "/trust/{id}",
    params: {
      clientId: null,
      matterId: null
    },
    views: {
      edit: {
        template: require("../accounting/views/trust.matter.html"),
        controller: "TrustMatterCtrl"
      }
    }
  });
}]);